import React from 'react'
import { TopBarSection, TopBarTitle, WidgetContent, TextField } from '@duik/it'
import TopBarMenuDivider from './TopBarMenuDivider'
import XIcon from '@material-ui/icons/CloseOutlined'
import SearchIcon from '@material-ui/icons/SearchOutlined'
import PlusIconButton from './PlusIconButton'
import LoadingIcon from '../components/LoadingIcon'

type TableTopSectionProps = {
  title: string
  loading?: boolean
  searchString?: string | JSX.Element
  searchSubmit?: (value: React.FormEvent<HTMLFormElement>) => void
  searchXButtonPress?: () => void
  searchValue?: string
  setSearchValue?: (value: string) => void
  handlePlusIconClick?: () => void
  additionalElement?: JSX.Element
  isCreateNew?: boolean
  rightSideElements?: JSX.Element
}

const TableTopSection = (props: TableTopSectionProps) => (
  <WidgetContent style={{ padding: '8px 0px' }} className="uik-widget-content__wrapper">
    <TopBarSection
      style={{ padding: '0px 30px', display: 'flex', justifyContent: 'space-between' }}
    >
      {!props.isCreateNew ? (
        <>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <TopBarTitle style={{ padding: 0, width: 'auto', fontSize: '18px' }}>
              {props.title}
            </TopBarTitle>
            <TopBarMenuDivider />
            {props.loading && <LoadingIcon />}
            {!props.loading && (
              <p style={{ fontSize: '14px', color: '#555858', padding: '0' }}>
                {props.searchString}
              </p>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {props.setSearchValue && (
              <form onSubmit={e => (props.searchSubmit ? props.searchSubmit(e) : undefined)}>
                <TextField
                  rightEl={
                    props.searchValue && props.searchValue.length > 0 ? (
                      <XIcon
                        onClick={() =>
                          props.searchXButtonPress ? props.searchXButtonPress() : undefined
                        }
                      />
                    ) : (
                      <SearchIcon />
                    )
                  }
                  placeholder="Search"
                  onChange={e =>
                    props.setSearchValue ? props.setSearchValue(e.target.value) : undefined
                  }
                  value={props.searchValue}
                  className="halfWidthInputBox"
                  wrapperProps={{ style: { marginRight: '10px' } }}
                />
              </form>
            )}
            {props.additionalElement}
            {props.handlePlusIconClick && (
              <PlusIconButton
                onClick={() =>
                  props.handlePlusIconClick ? props.handlePlusIconClick() : undefined
                }
              />
            )}
          </div>
        </>
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'center', height: '50px' }}>
            <TopBarTitle style={{ padding: 0, width: 'auto' }}>{props.title}</TopBarTitle>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>{props.rightSideElements}</div>
        </>
      )}
    </TopBarSection>
  </WidgetContent>
)

export default TableTopSection
